import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { Role, User } from '@/interfaces/user'

@Component
export default class AuthFilter extends Vue {
  @State(state => state.user.me) me!: User

  Role = Role
  // 获取角色，判断一些单独的权限操作
  getRole () {
    if (!this.me) {
      return false
    }
    const role: Role = this.me.role
    switch (role) {
      case Role.ROOT:
        return 'root'
      case Role.ADMIN:
        return 'admin'
      case Role.DEALER:
        return 'dealer'
      default:
        return false
    }
  }

  // 菜单权限
  rolesGuard (roles: string[]) {
    const { me } = this
    const privilege = roles.find((role: string) => {
      return me.role === role
    })
    if (!privilege || !me) {
      return false
    } else {
      return true
    }
  }
}
